import React from 'react'
import { getPriceClassDetails, getPricingDetails } from '../external/actions'
import { connect } from 'react-redux'
import { Pane, SelectField, toaster } from 'evergreen-ui'
import BackBar from '../components/backBar'
import Loader from '../components/loader'
import PriceSlotsPane from '../components/priceSlotsPane'
import EditPrice from '../components/editprice'
import update from 'immutability-helper'
import {
  getCurrentTime,
  modifyPriceSlots,
  validateCreditsAndPrice,
  validateNumber2,
  validatePercentage,
  isHourlyPrice
} from '../util'

import { editPrice } from '../external/actions'
class Pricing extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      priceClass: '',
      activityId: '',
      pricingType: '',
      loader: false,
      isShown: false,
      pricingData: '',
      holiday: false,
      startDay: 0,
      endDay: 6,
      isInvalid: false,
      test: false,
      daysData: {
        monday: 0,
        tuesday: 1,
        wednesday: 2,
        thursday: 3,
        friday: 4,
        saturday: 5,
        sunday: 6
      }
    }
    this.baseState = this.state
  }

  getPricingDetails = async () => {
    const { priceClass, activityId } = this.state
    await this.setState({
      loader: true
    })
    await this.props.dispatch(getPricingDetails({ priceClass, activityId }))
    await this.setState({
      loader: false
    })
  }

  // -----------------------------------------------------------------------
  // handleStartDayChange()
  // -----------------------------------------------------------------------
  handleStartDayChange = async e => {
    await this.setState({ startDay: parseInt(e.target.value) })
  }

  // -----------------------------------------------------------------------
  // handleEndDayChange()
  // -----------------------------------------------------------------------
  handleEndDayChange = async e => {
    await this.setState({ endDay: parseInt(e.target.value) })
  }

  editPrice = async (status, pricing, pricingType) => {
    if (status == true) {
      if (pricing.startDay.toLowerCase() === 'holiday') {
        await this.setState({
          holiday: true
        })
      } else {
        await this.setState({
          endDay: this.state.daysData[pricing.endDay.toLowerCase()],
          startDay: this.state.daysData[pricing.startDay.toLowerCase()]
        })
      }
      let modifiedPriceSlots = await modifyPriceSlots(pricing)
      
      this.setState({
        pricingData: modifiedPriceSlots,
        isShown: status,
        pricingType: pricingType
      })
    }

    if (status == false) {
      this.setState({
        loader: false,
        isShown: false,
        pricingData: '',
        holiday: false,
        startDay: 0,
        endDay: 6,
        isInvalid: false,
        daysData: {
          monday: 0,
          tuesday: 1,
          wednesday: 2,
          thursday: 3,
          friday: 4,
          saturday: 5,
          sunday: 6
        }
      })
    }
  }

  handleAddSlot = async () => {
    const priceSlots = this.state.pricingData
    let priceSlotObj = {
      startTime: getCurrentTime('HH:mm:ss'),
      endTime: getCurrentTime('HH:mm:ss'),
      pricingAmount: '',
      slotDiscount: [['', '']],
      bulkDiscount: {},
      isInvalid: false
    }
    const newPriceSlots = update(priceSlots, {
      priceSlots: { $push: [priceSlotObj] }
    })

    this.setState({
      pricingData: newPriceSlots
    })
  }

  handleRemoveSlot = async index => {
    const priceSlots = this.state.pricingData

    const newPriceSlots = update(priceSlots, {
      priceSlots: { $splice: [[index - 1]] }
    })

    this.setState({
      pricingData: newPriceSlots
    })
  }

  priceClassChange = async index => {
    const { priceClassData } = this.props
    index = parseInt(index)
    await this.setState({
      priceClass:
        priceClassData &&
        priceClassData['priceClasses'] &&
        priceClassData['priceClasses'][index]['priceClassId'],
      activityId:
        priceClassData &&
        priceClassData['priceClasses'] &&
        priceClassData['priceClasses'][index]['activityId'],
		test: !this.state.test 
    })
    await this.getPricingDetails()
  }

  handleVolumeDiscountChange = async (e, indexA, indexB) => {
    e.persist()
    if (validateNumber2(e.target.value) === 'set') {
      await this.mutateVolumeDiscount(e.target.value, indexA, indexB)
    } else if (validateNumber2(e.target.value) === 'clear') {
      await this.mutateVolumeDiscount('', indexA, indexB)
    }
  }

  mutateVolumeDiscount = async (value, indexA, indexB) => {
    const firstIndex = 0
    const priceSlots = this.state.pricingData

    const newPriceSlots = update(priceSlots, {
      priceSlots: {
        [indexA]: {
          slotDiscount: {
            [indexB]: {
              [firstIndex]: { $set: value }
            }
          }
        }
      }
    })
    await this.setState({ pricingData: newPriceSlots })
  }

  handleVolumeDiscountPercentageChange = async (e, indexA, indexB) => {
    e.persist()
    if (validatePercentage(e.target.value) === 'set') {
      await this.mutateVolumeDiscountPercentage(e.target.value, indexA, indexB)
    } else if (validatePercentage(e.target.value) === 'clear') {
      await this.mutateVolumeDiscountPercentage('', indexA, indexB)
    }
  }

  mutateVolumeDiscountPercentage = async (value, indexA, indexB) => {
    const secondIndex = 1
    const priceSlots = this.state.pricingData
    const newPriceSlots = update(priceSlots, {
      priceSlots: {
        [indexA]: {
          slotDiscount: {
            [indexB]: {
              [secondIndex]: { $set: value }
            }
          }
        }
      }
    })
    await this.setState({ pricingData: newPriceSlots })
  }

  handleHourlyPriceChange = async (e, index) => {
    if (validateCreditsAndPrice(e.target.value) === 'set') {
      await this.mutateHourlyPrice(e.target.value, index)
    } else if (validateCreditsAndPrice(e.target.value) === 'clear') {
      await this.mutateHourlyPrice('', index)
    }
  }

  mutateHourlyPrice = async (value, indexA) => {
    const priceSlots = this.state.pricingData
    const newPriceSlots = update(priceSlots, {
      priceSlots: {
        [indexA]: {
          pricingAmount: {
            $set: value
          },
          isInvalid: { $set: value === '' ? true : false }
        }
      }
    })
    await this.setState({ pricingData: newPriceSlots })
  }

  handleAddDiscountSlot = async indexA => {
    const priceSlots = this.state.pricingData

    const newPriceSlots = update(priceSlots, {
      priceSlots: { [indexA]: { slotDiscount: { $push: [['', '']] } } }
    })

    await this.setState({ pricingData: newPriceSlots })
  }

  modifyPriceSlots = async pricingType => {
    let modifiedPriceSlots = JSON.parse(JSON.stringify(this.state.pricingData))
    await modifiedPriceSlots.priceSlots.forEach(slot => {
      slot.price = slot.pricingAmount ? slot.pricingAmount.toString() : ''
      slot.slotDiscount = Object.fromEntries(
        slot.slotDiscount.filter(slot => slot[0] !== '' && slot[1] !== '')
      )
    })

    modifiedPriceSlots.priceSlots = await modifiedPriceSlots.priceSlots.map(
      ({ pricingAmount, day, pricingVersion, isInvalid, ...slot }) => slot
    )
   
    Object.assign(modifiedPriceSlots, {
      startDay: pricingType === 'holiday' ? 7 : this.state.startDay,
      endDay: pricingType === 'holiday' ? 7 : this.state.endDay
    })

    modifiedPriceSlots.slots = modifiedPriceSlots.priceSlots
    delete modifiedPriceSlots.pricingVersion
    delete modifiedPriceSlots.priceSlots
   
    return modifiedPriceSlots
  }

  handleRemoveDiscountSlot = async (indexA, index) => {
    const priceSlots = this.state.pricingData

    const newPriceSlots = update(priceSlots, {
      priceSlots: {
        [indexA]: {
          slotDiscount: { $splice: [[index, 1]] }
        }
      }
    })

    await this.setState({ pricingData: newPriceSlots })
  }

  async componentDidMount () {
    await this.props.dispatch(getPriceClassDetails())
    await this.priceClassChange(0)
    await this.getPricingDetails()
  }

  // -----------------------------------------------------------------------
  // mutateTime()
  // -----------------------------------------------------------------------
  mutateTime = async (indexB, timeValue, timeType) => {
    const priceSlots = this.state.pricingData
    const newPriceSlots = update(priceSlots, {
      priceSlots: {
        [indexB]: {
          [timeType]: { $set: timeValue }
        }
      }
    })
    await this.setState({ pricingData: newPriceSlots })
  }

  onConfirm = async () => {
    let { pricingData, priceClass, activityId, pricingType } = this.state
    let { pricingDetails } = this.props
    console.log({ pricingType })
    let isInvalid = await isHourlyPrice(pricingData)
    let priceSlots = await this.modifyPriceSlots(pricingType)
    console.log({ priceSlots })
    let reqBody = {
      priceClass: parseInt(priceClass),
      activityId: parseInt(activityId),
      isPeriodicPricing: false,
      startDate: '',
      endDate: '',
      pricing: [priceSlots]
    }
    if (!isInvalid) {
      await this.props.dispatch(editPrice(reqBody))
      if (this.props.editPriceData['requestStatus'] === 1) {
        toaster.success(this.props.editPriceData.message)

        await this.editPrice(false)
        await this.props.dispatch(getPriceClassDetails())

        await this.getPricingDetails()
      } else if (this.props.editPriceData['requestStatus'] === -1) {
        await this.editPrice(false)
      } else {
        toaster.warning(this.props.editPriceData.message)
      }
    } else {
      this.setState({
        isInvalid: true
      })
    }
  }

  render () {
    const { priceClassData, pricingDetails } = this.props
    
    const {
      loader,
      isShown,
      pricingData,
      endDay,
      startDay,
      holiday,
      isInvalid,
      test
    } = this.state

    return (
      <React.Fragment>
        <BackBar title={"Pricing"}/>

        <EditPrice
          endDay={endDay}
          startDay={startDay}
          isInvalid={isInvalid}
          handleStartDayChange={this.handleStartDayChange}
          handleEndDayChange={this.handleEndDayChange}
          handleAddDiscountSlot={this.handleAddDiscountSlot}
          isShown={isShown}
          pricing={pricingData}
          editPrice={this.editPrice}
          addSlot={this.handleAddSlot}
          removeSlot={this.handleRemoveSlot}
          handleRemoveDiscountSlot={this.handleRemoveDiscountSlot}
          mutateVolumeDiscount={this.handleVolumeDiscountChange}
          mutateDiscount={this.handleVolumeDiscountPercentageChange}
          mutateHourlyPrice={this.handleHourlyPriceChange}
          mutateTime={this.mutateTime}
          holiday={holiday}
          onConfirm={this.onConfirm}
        />
        <Pane
          position={'sticky'}
          top={60}
          paddingTop={10}
          paddingBottom={1}
          paddingLeft={16}
          paddingRight={16}
          background={'tint1'}
          onClick={() => this.setState({ test: !test })}
        >
          {test && (
            <Pane onClick={() => this.setState({ test: !test })}>Test</Pane>
          )}
          {priceClassData && (
            <SelectField
              label={'Select Sport'}
              onChange={e => this.priceClassChange(e.target.value)}
            >
              {priceClassData &&
                priceClassData['priceClasses'] &&
                priceClassData['priceClasses'].map((priceClass, index) => (
                  <option key={index} value={index} selected={index === 0}>
                    {priceClass['pricingClassName']}
                  </option>
                ))}
            </SelectField>
          )}
        </Pane>
        {loader ? (
          <Loader />
        ) : (
          <Pane>
            {pricingDetails && (
              <Pane margin={15} paddingBottom={5}>
                {pricingDetails['pricing'] &&
                  Object.keys(pricingDetails['pricing']).map(
                    (pricingType, index) =>
                      pricingDetails['pricing'][pricingType].length ? (
                        <PriceSlotsPane
                          key={index}
                          pricingDetails={pricingDetails}
                          pricingType={pricingType}
                          editPrice={this.editPrice}
                          isShown={isShown}
                        />
                      ) : (
                        <div />
                      )
                  )}
              </Pane>
            )}
          </Pane>
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({
  priceClassData,
  pricingDetails,
  editPriceData
}) => ({
  priceClassData,
  pricingDetails,
  editPriceData
})

export default connect(mapStateToProps)(Pricing)
